module.exports = __webpack_public_path__ + "static/img/noka.675f13e9.png";